<template>
  <div v-show="visible" :id="id" :class="[{'card__content__inner--center': center }]" class="card__content__inner">
    <slot />
  </div>
</template>

<script>

import { isEmpty, isNil, sampleSize } from 'lodash';

export default {
  name: 'TabableCardContent',

  mixins: [],

  props: {
    title: {
      type: String,
      default: '',
    },
    display: {
      type: Boolean,
      default: true,
      required: false,
    },
    center: {
      type: Boolean,
      default: false,
      required: false,
    },
    indicator: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      visible: false,
    };
  },

  computed: {
    id: function () {
      const id = this.$attrs.id || `comp_${this._uid}`;
      return isEmpty(this._parentHtmlId) ? id : `${this._parentHtmlId}-${id}`;
    },
    _parentHtmlId: function () {
      let it = this.$parent;
      while (!isNil(it)) {
        if (!isEmpty(it.id)) {
          return it.id;
        }
        it = it.$parent;
      }
      return '';
    },
  },

  watch: {
    visible: function (newValue, oldValue) {
      if (newValue === oldValue) return;

      if (newValue) {
        // next tick is required, because if @show does recalculate some visible content we need to wait for it to get visible
        this.$nextTick(() => {
          this.$emit('show');
        });
      } else {
        this.$emit('hide');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/lib/layout/TabableCardContent.vue